// extracted by mini-css-extract-plugin
export default {"wrapper":"gtTtPSph2LqWpnXajYMW","value":"j1CurpLB2P8Xf9qAfOoj"};